import { siteInfo } from "@/mocks/site-info";

interface SEOHeadProps {
  title?: string;
  description?: string;
  keywords?: string;
  canonicalUrl?: string;
  ogType?: string;
  ogImage?: string;
  articlePublishedTime?: string;
  articleModifiedTime?: string;
}

export default function SEOHead({
  title,
  description,
  keywords,
  canonicalUrl,
  ogType = "website",
  ogImage,
  articlePublishedTime,
  articleModifiedTime,
}: SEOHeadProps) {
  const pageTitle = title
    ? `${title} - ${siteInfo.name}`
    : `${siteInfo.name} - ${siteInfo.tagline}`;

  const pageDescription = description || siteInfo.description;
  const pageKeywords = keywords || siteInfo.keywords;
  const pageUrl = canonicalUrl || siteInfo.url;
  const pageImage =
    ogImage ||
    "https://readdy.ai/api/search-image?query=Inspiring%20movie%20guide%20website%20header%20image%2C%20warm%20golden%20tones%2C%20cinematic%20atmosphere%2C%20books%20and%20film%20elements%2C%20elegant%20typography%20feel%2C%20minimalist%20composition&width=1200&height=630&seq=og-default&orientation=landscape";

  useEffect(() => {
    document.title = pageTitle;

    const setMeta = (name: string, content: string, prop = false) => {
      const attr = prop ? "property" : "name";
      let el = document.querySelector(`meta[${attr}="${name}"]`) as HTMLMetaElement | null;
      if (!el) {
        el = document.createElement("meta");
        el.setAttribute(attr, name);
        document.head.appendChild(el);
      }
      el.setAttribute("content", content);
    };

    setMeta("description", pageDescription);
    setMeta("keywords", pageKeywords);

    setMeta("og:title", pageTitle, true);
    setMeta("og:description", pageDescription, true);
    setMeta("og:type", ogType, true);
    setMeta("og:url", pageUrl, true);
    setMeta("og:image", pageImage, true);
    setMeta("og:locale", siteInfo.locale, true);
    setMeta("og:site_name", siteInfo.name, true);

    setMeta("twitter:card", "summary_large_image");
    setMeta("twitter:title", pageTitle);
    setMeta("twitter:description", pageDescription);
    setMeta("twitter:image", pageImage);

    if (articlePublishedTime) {
      setMeta("article:published_time", articlePublishedTime, true);
    }
    if (articleModifiedTime) {
      setMeta("article:modified_time", articleModifiedTime, true);
    }

    let link = document.querySelector('link[rel="canonical"]') as HTMLLinkElement | null;
    if (!link) {
      link = document.createElement("link");
      link.rel = "canonical";
      document.head.appendChild(link);
    }
    link.href = pageUrl;
  }, [pageTitle, pageDescription, pageKeywords, pageUrl, pageImage, ogType, articlePublishedTime, articleModifiedTime]);

  return null;
}